<template>
  <div>
    <MemberAssociatedSites
      :member="mutableValue"
      :memberId="memberId"
    />
  </div>
</template>
<script>

import MemberAssociatedSites from '@/views/member/MemberAssociatedSites';

export default {
    components: { MemberAssociatedSites },
    props: {
        mutableValue: {
            type: Object,
            default: () => ({ empty: true }),
        },
        member: {
            type: Object,
            default: () => ({ empty: true }),
        },
        memberId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            name: '',
            lastName: '',
            phone: '',
            email: '',
        };
    },
};
</script>
